<template>
  <div class="ProjectOperation">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-card-title class="title">
              Operativos del Proyecto: {{ project.nombre_proyecto }}
              <v-spacer/>

              <v-text-field
                :disabled="dataVals.length < 0 || loading"
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer/>

              <!-- <v-card-actions>
                <v-btn color="info" :disabled="dataVals.length === 0">
                  <download-csv
                    :data="dataVals"
                    :name="''"
                    :labels="labelsTotal"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions> -->

              <v-dialog v-model="dialog" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="loading"
                    color="info" dark v-on="on"
                  >
                    Nuevo Operativo
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }} : {{ editedOperation.nombre_operativo }}</span> <br>
                    <span>Token: {{ editedOperation.token }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form
                      ref="form"
                      v-model="form"
                    >
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedOperation.nombre_operativo"
                              label="Nombre Operativo*"
                              :rules="operationRules"
                              counter="20"
                              required
                            >
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-autocomplete
                              v-model="editedOperation.proyecto"
                              hint="Seleccione el proyecto"
                              :items="projects"
                              item-text="nombre_proyecto"
                              item-value="id"
                              label="Proyectos"
                              no-data-text="No se tienen proyectos"
                            />
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedOperation.fecha_inicio"
                              label="Fecha de Inicio"
                              type="date"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedOperation.fecha_fin"
                              label="Fecha de Finalización"
                              type="date"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md12>
                            <v-autocomplete
                              :items="questions"
                              label="Pregunta para Filtro"
                              v-model="editedOperation.config.filtros"
                              :disabled="loadingQuestions || editedIndex === -1"
                              color="secondary"
                              item-text="label"
                              item-value="id"
                              hide-no-data
                              hide-selected
                              multiple
                              chips
                              deletable-chips
                              :loading="loadingQuestions"
                              @input="searchInput=null"
                              :search-input.sync="searchInput">
                            ></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 md5>
                            <v-text-field
                              v-model="editedOperation.nvl_repets"
                              label="Nivel de Repeats"
                              mask="###"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md7>
                            <v-text-field
                              v-model="editedOperation.enc_x_encuestador"
                              label="Encuestas por Encuestador"
                              mask="####"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md12>
                            <v-text-field
                              v-model="editedOperation.enc_total"
                              label="Meta de Encuestas por Operativo"
                              mask="#####"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md12>
                            <v-autocomplete
                              :items="questions"
                              label="Operativo Telefónico"
                              v-model="editedOperation.config.filtros"
                              :disabled="loadingQuestions || editedIndex === -1"
                              color="secondary"
                              item-text="label"
                              item-value="id"
                              hide-no-data
                              hide-selected
                              :loading="loadingQuestions"
                              @input="searchInput=null"
                              :search-input.sync="searchInput">
                            >
                              <template v-slot:append-outer>
                                <v-slide-x-reverse-transition
                                  mode="out-in"
                                >
                                  <v-icon large
                                    :disabled="editedIndex === -1"
                                    color="success"
                                    @click="addPhoneOper()"
                                  >settings_phone</v-icon>
                                </v-slide-x-reverse-transition>
                              </template>
                            </v-autocomplete>
                          </v-flex>

                        </v-layout>
                      </v-container>
                      <small>* Campos obligatorios</small>
                    </v-form>
                  </v-card-text>

                  <v-alert :value="alert" type="error">
                    No se ha podido realizar la operación
                  </v-alert>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="info" :disabled="uploading" @click="close()">Cancelar</v-btn>
                    <v-btn
                      :disabled="!form || uploading"
                      color="success"
                      @click="save()"
                    >Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                :value="completed"
                color="info"
              >
                {{ progressAdvance }}
                {{ progressTotal }}
              </v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                :key="tableOperationKey"
                dense
                :headers="headers"
                :items="dataVals"
                :search="search"
                :custom-filter="customFilter"
                no-results-text="No se encontro el término buscado"
                no-data-text="No hay datos disponibles"
                multi-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
                rows-per-page-text="Filas por página:"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td v-for="col in columns" :key="col.id">{{ props.item[col] }}</td> -->
                  <td>{{ props.item.nombre_operativo }}</td>
                  <td>{{ props.item.fecha_inicio }}</td>
                  <td>{{ props.item.fecha_fin }}</td>
                  <td>{{ proyectName(props.item.proyecto) }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      color="info"
                      @click="editOperation(props.item)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      color="error"
                      @click="deleteOperation(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-dialog v-model="dialogDelete" persistent max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Eliminar Operativo</span>
                </v-card-title>
                <v-card-text>
                  Seguro que quiere eliminar el operativo: <br>
                  <span class="title">
                    {{ editedOperation.nombre_operativo }}
                  </span> <br>
                  Esta acción no se puede deshacer
                  <v-checkbox
                    v-model="checkbox"
                    label="Confirmo que deseo eliminar los datos del operativo"
                  ></v-checkbox>
                </v-card-text>

                <v-alert :value="alert" type="error">
                  No se ha podido eliminar el operativo
                </v-alert>

                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="info" :disabled="uploading" @click="close()">Cancelar</v-btn>
                  <v-btn
                    color="error"
                    @click="byeOperation()"
                    :disabled="!checkbox || uploading"
                  >Eliminar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>

          <!-- <pretty-json
            :data="editedOperation"
          ></pretty-json> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// import JsonPretty from 'vue-json-pretty'
// import JsonCSV from 'vue-json-csv'

export default {
  name: `ProjectOperation`,

  components: {
    // 'download-csv': JsonCSV,
    // 'pretty-json': JsonPretty
  },

  /** Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.project = this.$store.state.actualProject
    this.getProjects()
    this.getOperation()
  },

  data: function () {
    return {
      backConf: {
        pathList: '/core/operational/?page=',
        pathPrjList: '/core/projects/?page=',
        pathCUD: '/core/operational/', // Post sin documento demas con documento
        pathQuestion: '/formularios/operaciones/', // endpoint para ver fileds y choices
        page: 1
      },

      project: null,
      operativo: null,

      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,

      loading: false,
      uploading: false,
      form: false,
      checkbox: false,

      alert: false,

      questions: [],
      searchInput: null,
      loadingQuestions: false,

      headers: [
        // {
        //   text: 'Identificador',
        //   align: 'left',
        //   value: 'id'
        // },
        { text: 'Nombre Operativo', value: 'nombre_operativo', align: 'left' },
        { text: 'Inicio', value: 'fecha_inicio' },
        { text: 'Fin', value: 'fecha_fin' },
        { text: 'Proyecto', value: 'proyecto' },
        { text: 'Acciones', value: '', align: 'left', sortable: false }
      ],
      dataVals: [],
      projects: [],

      defaultOperation: {
        'nombre_operativo': '',
        'fecha_inicio': new Date().toISOString().substr(0, 10),
        'fecha_fin': null,
        'vistas': {},
        'config': {},
        'nvl_repets': 3,
        'enc_x_encuestador': 100,
        'enc_total': 1000,
        'proyecto': null
      },
      tableOperationKey: 0,

      search: '',
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedOperation: {
        'nombre_operativo': '',
        'fecha_inicio': new Date().toISOString().substr(0, 10),
        'fecha_fin': null,
        'vistas': {},
        'config': {},
        'nvl_repets': 3,
        'enc_x_encuestador': 100,
        'enc_total': 1000,
        'proyecto': null
      },

      operationRules: [
        v => !!v || 'Se requiere nombre de operativo',
        v => (v.length < 21) || 'Maximo 20 caracteres'
      ]
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },

    editedOperation: function () {
      if (this.editedOperation.id) {
        this.getQuestions()
      }
    },

    'dataVals': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  computed: {
    /** Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })

      colVals.pop() // remueve la columna final, para alinear los iconos
      return colVals
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Operativo' : 'Editar Operativo'
    }
  },

  methods: {
    /** Carga la información de todos los proyectos
     */
    getProjects () {
      this.loading = true
      let request = {
        method: 'get',
        params: {},
        url: this.backConf.pathPrjList + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.projects = t.projects.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getProjects()
          } else {
            t.backConf.page = 1
            t.tableOperationKey += 1
            t.loading = false
          }
        })
        .catch(function (err) {
          t.projects = []
          t.alert = true
          t.loading = false
          t.tableOperationKey += 1
          console.error(err)
        })
    },

    /** Carga la información de todos los operativos
     */
    getOperation () {
      this.loading = true
      let request = {
        method: 'get',
        params: {},
        url: this.backConf.pathList + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.dataVals.length

          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.tableOperationKey += 1
            t.getOperation()
          } else {
            t.backConf.page = 1
            t.tableOperationKey += 1
            t.loading = false
          }
        })
        .catch(function (err) {
          t.dataVals = []
          t.alert = true
          t.loading = false
          t.tableOperationKey += 1
          console.error(err)
        })
    },

    /** Carga los datos del operativo seleccionado y abre el dialog
     * @param  {Object} operation El operativo a editar
     */
    editOperation (operation) {
      this.editedIndex = this.dataVals.indexOf(operation)
      this.editedOperation = Object.assign({}, operation)
      this.dialog = true
    },

    /** Carga los datos del operativo seleccionado y abre el dialog
     * @param  {Object} operation El operativo a eliminar
     */
    deleteOperation (operation) {
      this.editedIndex = this.dataVals.indexOf(operation)
      this.editedOperation = Object.assign({}, operation)
      this.dialogDelete = true
    },

    /** Elimina el usaurio seleccionado, previa confirmación
     * actualiza la tabla local
     */
    byeOperation () {
      this.uploading = true
      let request = {
        method: 'delete',
        data: {},
        url: this.backConf.pathCUD + this.editedOperation.id + '/'
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals.splice(t.editedIndex, 1)
          t.alert = false
          t.uploading = false
          t.tableOperationKey += 1
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          t.uploading = false
          t.tableOperationKey += 1
          console.error(err)
        })
    },

    /** Limpia el formulario de operativo y setea el index del elemento
     */
    close () {
      this.questions = []
      this.dialog = false
      this.alert = false
      this.dialogDelete = false
      setTimeout(() => {
        this.editedOperation = Object.assign({}, this.defaultOperation)
        this.editedIndex = -1
      }, 300)
    },

    /** Guarda la información del operativo,
     * sea un operativo nuevo o una actualización
     * actualiza la tabla local
     */
    save () {
      this.uploading = true
      let request = {
        method: this.editedIndex > -1 ? 'put' : 'post',
        data: this.editedOperation,
        url: this.editedIndex > -1 ? this.backConf.pathCUD + this.editedOperation.id + '/' : this.backConf.pathCUD
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (t.editedIndex > -1) {
            Object.assign(t.dataVals[t.editedIndex], t.editedOperation)
          } else {
            t.dataVals.push(t.editedOperation)
          }
          t.alert = false
          t.uploading = false
          t.tableOperationKey += 1
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          t.uploading = false
          t.tableOperationKey += 1
          console.error(err)
        })
    },

    /**
     * CAmbia el id del proyecto por su respectivo nombre
     * @param  {integer} prjid id del proyecto
     * @return {string}        el nombre del proyecto
     */
    proyectName (prjid) {
      let prj = this.projects.filter(prj => prj.id === prjid)
      return prj[0].nombre_proyecto
    },

    /**
     * Obtiene la lista de preguntas para el operativo
     */
    getQuestions () {
      this.loadingQuestions = true

      let request = {
        method: 'get',
        params: {
          operativo: this.editedOperation.id
        },
        url: this.backConf.pathQuestion
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.questions = resp.data
          t.loadingQuestions = false
        })
        .catch(function (err) {
          t.questions = []
          t.loadingQuestions = false
          console.error(err)
        })
    },

    getPhoneOper () {

    },

    addPhoneOper () {

    }
  }
}
</script>
